(function() {

    'use strict';

    angular.module('itxApp.common')
        .factory('mdUtils', ItxDuttiCons);

    ItxDuttiCons.$inject = [
        'DUTTI_CONS',
        'CommonServices'
    ];

    function ItxDuttiCons (
        DUTTI_CONS,
        CommonServices
    ) {

        return {
            linkDownloadApp: _linkDownloadApp,
            stringTransformAllowed: _stringTransformAllowed,
            firstCapitalLetter: _firstCapitalLetter,
            getLinkDownloadApp: _getLinkDownloadApp,
            decodeBase64: _decodeBase64,
            getLinkSmartAppCategory: _getLinkSmartAppCategory,
            // functions Deprecated. Se debe utilizar el servicio CommonServices
            isExplorer: CommonServices.isExplorer,
            isWebapp: CommonServices.isWebapp,
            upperCaseText: _upperCaseText
        };

        function _linkDownloadApp(param) {
            window.open(_getLinkDownloadApp(param), '_blank');
        }

        function _getLinkSmartAppCategory(){
            return joyr.utils.getCommonPageUrl('smart-app-c1791035', false, false);
        }

        function _getLinkDownloadApp(param){
            var storeUrl = "";
            var iosApp = 'https://itunes.apple.com/app/massimo-dutti/id373282826?mt=8';
            var androidApp = 'https://play.google.com/store/apps/details?id=com.inditex.massimodutti';
            var smartApp = _getLinkSmartAppCategory();
            var userAgent = joyr.utils.getOperatingSystem(navigator.userAgent);

            if(!param && userAgent){
                param = userAgent.toLowerCase();
            }

            if(inditex.iCountryCode === 'CN'){
                androidApp = 'http://android.myapp.com/myapp/detail.htm?apkName=com.inditex.massimodutti';
            }

            switch(param) {
                case 'android':
                    storeUrl = androidApp
                    break;
                case 'ios':
                    storeUrl = iosApp
                    break;
                default:
                    storeUrl = smartApp
                    break;
            }

            return  `https://static.massimodutti.net/3/static2/itxwebstandard/download-app/index.html?device=${param}&resource=${storeUrl}`
        }

        function _stringTransformAllowed(){
            let langNotAllowed = DUTTI_CONS.i_langNoGeneric[inditex.iLangId];
            if(langNotAllowed){
                return false;
            } else {
                return true;
            }
        }

        function _firstCapitalLetter(text){
            if(!text || text === ''){
                return '';
            }
            if(_stringTransformAllowed()){
                return text.charAt(0).toUpperCase() + text.substring(1).toLowerCase();
            } else {
                return text;
            }
        }

        /**
         * Función para decodificar hashes en Base64
         */
        function _decodeBase64(input) {

            var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            var output = "";
            var chr1, chr2, chr3;
            var enc1, enc2, enc3, enc4;
            var i = 0;

            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

            while (i < input.length) {
                enc1 = _keyStr.indexOf(input.charAt(i++));
                enc2 = _keyStr.indexOf(input.charAt(i++));
                enc3 = _keyStr.indexOf(input.charAt(i++));
                enc4 = _keyStr.indexOf(input.charAt(i++));
                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;
                output = output + String.fromCharCode(chr1);
                if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }
            output = _utf8_decode(output);

            return output;

        }

        function _utf8_decode(utftext) {
            var string = "";
            var i = 0;
            var c = 0;
            var c2 = 0;
            var c3 = 0;
            while ( i < utftext.length ) {
                c = utftext.charCodeAt(i);
                if (c < 128) {
                    string += String.fromCharCode(c);
                    i++;
                }
                else if((c > 191) && (c < 224)) {
                    c2 = utftext.charCodeAt(i+1);
                    string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                    i += 2;
                }
                else {
                    c2 = utftext.charCodeAt(i+1);
                    c3 = utftext.charCodeAt(i+2);
                    string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                    i += 3;
                }
            }
            return string;
        }

        /**
         * Función para transformar texto a mayúsculas en función del idioma
         */
        function _upperCaseText(text) {
            if (text) {
                if (_stringTransformAllowed()) {
                    return text.toUpperCase();
                } else {
                    return text;
                }
            }

            return '';
        }
    }

})();